import { AuthHelpers } from "@/lib/auth/AuthHelpers";

export function useDeviceKey() {
  const authDeviceKey = AuthHelpers.getGetOrCreateKey(import.meta.env.VITE_IBABS_AUTH_DEVICE_KEY);

  return authDeviceKey;
}
